export default __webpack_public_path__ + "static/media/clerk@3x.9e1f6687.png";